import { Button } from "@/components/ui/button";
import { SlidersHorizontal } from "lucide-react";

interface AltsChartHeaderProps {
  totalAllocation: number;
  onEditClick: () => void;
}

const AltsChartHeader = ({ totalAllocation, onEditClick }: AltsChartHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div className="text-sm font-medium">
        Visible Allocation: <span className={totalAllocation === 100 ? "text-green-600" : "text-[#ea384c]"}>
          {totalAllocation}%
        </span>
      </div>
      <Button variant="outline" size="sm" onClick={onEditClick}>
        <SlidersHorizontal className="mr-2 h-4 w-4" />
        ADJUST
      </Button>
    </div>
  );
};

export default AltsChartHeader;